import { Box, Button, LinearProgress, Typography } from '@mui/joy';

export default function ChatQueueStatus({ job, onRetry, onDiscard }) {
  if (!job) return null;
  const total = job.batches.length;
  return (
    <Box sx={{ px: 1.5, py: 1, flexShrink: 0 }} role="status" aria-live="polite">
      <Typography level="body-sm">
        {job.running ? 'Отправка' : job.error ? 'Отправка приостановлена' : 'Очередь приостановлена'}
        {job.files.length ? <> · {job.sentFiles} из {job.files.length} файлов · группы {job.next} из {total}</> : ' · сообщение'}
      </Typography>
      <LinearProgress determinate value={100 * job.next / total} sx={{ my: 0.75 }} />
      {job.running && <Typography level="body-xs">Не закрывайте страницу до конца отправки.</Typography>}
      {job.error && <Typography level="body-xs" color="danger">{job.error}</Typography>}
      {!job.running && (
        <>
          <Typography level="body-xs" sx={{ mb: 0.5 }}>
            Повтор продолжит очередь. Если ответ потерялся, сервер вернёт уже отправленное сообщение.
            При закрытии страницы оставшаяся очередь не сохранится.
          </Typography>
          <Button size="sm" onClick={onRetry}>Продолжить отправку</Button>
          <Button size="sm" variant="plain" color="neutral" onClick={onDiscard} sx={{ ml: 1 }}>
            Убрать оставшиеся
          </Button>
        </>
      )}
    </Box>
  );
}
